import { Component } from '@theme/component';

/**
 * Horizontal card strip (photos, reviews …) with previous/next buttons.
 * Scrolling is native (scroll-snap); the buttons move the strip by one card.
 *
 * @extends {Component<{ track: HTMLElement, cards: HTMLElement[] }>}
 */
class EsmeCarousel extends Component {
  requiredRefs = ['track'];

  previous() {
    this.#scrollByCards(-1);
  }

  next() {
    this.#scrollByCards(1);
  }

  /**
   * @param {number} direction - 1 for forward, -1 for backward.
   */
  #scrollByCards(direction) {
    const { track, cards } = this.refs;
    const card = cards?.[0];
    if (!card) return;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const isRtl = getComputedStyle(this).direction === 'rtl';
    const step = (card.offsetWidth + gap) * direction * (isRtl ? -1 : 1);

    track.scrollBy({ left: step, behavior: 'smooth' });
  }
}

if (!customElements.get('esme-carousel')) {
  customElements.define('esme-carousel', EsmeCarousel);
}
